
import { Carrier } from './carrier.model';
import { NewHire } from './new-hire.model'
import { Broker } from './broker.model';
export class RootObject {
    constructor() {
        this.NewHires = new Array<NewHire>();
        this.Broker = new Broker();
        this.Carrier = new Carrier();;
    }
    Id:number=0;
    UserName: string;
    UserEmail: string;
    GroupId: number;
    GroupName: string;
    ZipCode: string;
    CountyName: string;
    CountyCode: string;
    SICCode: string;
    SICCodeId: 1
    SICCodeDetail: string;
    SICDescription: string;
    State: string;
    AgencyId: number;
    EffectiveDate: string;
    NHWSShareFileUrl: string;
    NHWSShareFileLinkExpiry: string;
    Broker: Broker;
    NewHires: NewHire[];
    CreatedDate:string;
    MedicalRenewalDate:string;
    CreatedBy:string;
    Carrier: Carrier;
    AgencyName:string;
    DeliveryEmail: string;
    IsCombinedPdf: boolean;
    AddEmployeeEnrollmentSheet: boolean;
    AddMemberLevelEnrollmentSheet: boolean;
}